export const RegisteredAgent = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6319_37318)">
      <path
        d="M12 15C14.0711 15 15.75 13.3211 15.75 11.25C15.75 9.17893 14.0711 7.5 12 7.5C9.92893 7.5 8.25 9.17893 8.25 11.25C8.25 13.3211 9.92893 15 12 15Z"
        stroke="#706A85"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9812 18.6909C6.54549 17.5795 7.40654 16.6459 8.4689 15.9939C9.53126 15.3418 10.7534 14.9966 12 14.9966C13.2465 14.9966 14.4686 15.3418 15.531 15.9939C16.5934 16.6459 17.4544 17.5795 18.0187 18.6909"
        stroke="#706A85"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8753 10.5C21.1917 12.38 20.9025 14.3119 20.0493 16.0168C19.1961 17.7217 17.8231 19.1113 16.1287 19.985C14.4342 20.8587 12.5059 21.1713 10.6222 20.8776C8.73855 20.5839 6.99693 19.6992 5.64887 18.3511C4.3008 17.0031 3.41605 15.2614 3.12237 13.3778C2.82868 11.4941 3.14126 9.56577 4.01496 7.87131C4.88867 6.17685 6.27829 4.80391 7.98317 3.95073C9.68806 3.09755 11.62 2.80828 13.5 3.12469"
        stroke="#706A85"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip1_6319_37318)">
        <path
          d="M16.4062 5.0625L18.375 7.03125L22.875 2.53125"
          stroke="#706A85"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6319_37318">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_6319_37318">
        <rect width="9" height="9" fill="white" transform="translate(15)" />
      </clipPath>
    </defs>
  </svg>
);
